export default __webpack_public_path__ + "resources/icons/n230-8dae.webp";